
//測試用資料
let bikeCityData =[
    {
      "StationUID": "TPE0001",
      "StationID": "0001",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_捷運市政府站(3號出口)",
        "En": "YouBike1.0_MRT Taipei City Hall Stataion(Exit 3)-2"
      },
      "StationPosition": {
        "PositionLon": 121.567904444,
        "PositionLat": 25.0408578889,
        "GeoHash": "wsqqqqe19"
      },
      "StationAddress": {
        "Zh_tw": "忠孝東路/松仁路(東南側)",
        "En": "The S.W. side of Road Zhongxiao East Road & Road Chung Yan."
      },
      "BikesCapacity": 180,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:31+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0002",
      "StationID": "0002",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_捷運國父紀念館站(2號出口)",
        "En": "YouBike1.0_MRT S.Y.S Memorial Hall Stataion(Exit 2.)"
      },
      "StationPosition": {
        "PositionLon": 121.55742,
        "PositionLat": 25.041254,
        "GeoHash": "wsqqqne7v"
      },
      "StationAddress": {
        "Zh_tw": "忠孝東路四段/光復南路口(西南側)",
        "En": "Sec,4. Zhongxiao E.Rd/GuangFu S. Rd"
      },
      "BikesCapacity": 32,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:42+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0003",
      "StationID": "0003",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_台北市政府",
        "En": "YouBike1.0_Taipei City Hall"
      },
      "StationPosition": {
        "PositionLon": 121.565169444,
        "PositionLat": 25.0377972222,
        "GeoHash": "wsqqqmcp9"
      },
      "StationAddress": {
        "Zh_tw": "台北市政府東門(松智路) (鄰近信義商圈/台北探索館)",
        "En": "Taipei City Government Eastgate (Song Zhi Road)"
      },
      "BikesCapacity": 40,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:24+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0004",
      "StationID": "0004",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_市民廣場",
        "En": "YouBike1.0_Citizen Square"
      },
      "StationPosition": {
        "PositionLon": 121.562325,
        "PositionLat": 25.0360361111,
        "GeoHash": "wsqqqjwvr"
      },
      "StationAddress": {
        "Zh_tw": "市府路/松壽路(西北側)(鄰近台北101/台北世界貿易中心/台北探索館)",
        "En": "The N.W. side of Road Shifu & Road Song Shou."
      },
      "BikesCapacity": 32,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:34+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0005",
      "StationID": "0005",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_興雅國中",
        "En": "YouBike1.0_Xingya Jr. High School"
      },
      "StationPosition": {
        "PositionLon": 121.5686639,
        "PositionLat": 25.0365638889,
        "GeoHash": "wsqqqmg8e"
      },
      "StationAddress": {
        "Zh_tw": "松仁路/松仁路95巷(東南側)(鄰近信義商圈/台北信義威秀影城)",
        "En": "The S.E. side of Road Songren & Ln. 95, Songren Rd.."
      },
      "BikesCapacity": 60,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:37+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0006",
      "StationID": "0006",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_臺北南山廣場",
        "En": "YouBike1.0_NAN SHAN PLAZA"
      },
      "StationPosition": {
        "PositionLon": 121.565973,
        "PositionLat": 25.034047,
        "GeoHash": "wsqqqm39u"
      },
      "StationAddress": {
        "Zh_tw": "松智路/松廉路(東北側) (鄰近台北101/信義商圈/台北信義威秀影城)",
        "En": "The N.E. side of Road Song Zhi & Road Song Lian."
      },
      "BikesCapacity": 80,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:42+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0007",
      "StationID": "0007",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_信義廣場(台北101)",
        "En": "YouBike1.0_Xinyi Square(Taipei 101)"
      },
      "StationPosition": {
        "PositionLon": 121.565619444,
        "PositionLat": 25.0330388889,
        "GeoHash": "wsqqqm1kh"
      },
      "StationAddress": {
        "Zh_tw": "松智路/信義路(東北側) (鄰近台北101)",
        "En": "The N.E. side of Road Song Zhi & Road Xinyi."
      },
      "BikesCapacity": 80,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:15+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0008",
      "StationID": "0008",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_世貿三館",
        "En": "YouBike1.0_TWTC Exhibition Hall 3"
      },
      "StationPosition": {
        "PositionLon": 121.563688889,
        "PositionLat": 25.0352138889,
        "GeoHash": "wsqqqjxbx"
      },
      "StationAddress": {
        "Zh_tw": "市府路/松壽路(東南側) (鄰近台北101/台北世界貿易中心/台北探索館)",
        "En": "The S.E. side of Road Shifu & Road Song Shou."
      },
      "BikesCapacity": 36,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:38+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0009",
      "StationID": "0009",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_松德站",
        "En": "YouBike1.0_Songde"
      },
      "StationPosition": {
        "PositionLon": 121.57448,
        "PositionLat": 25.031785,
        "GeoHash": "wsqqqkzud"
      },
      "StationAddress": {
        "Zh_tw": "台北市信義區松德路300號",
        "En": "No.300, Songde Rd.(32)"
      },
      "BikesCapacity": 40,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:39+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0010",
      "StationID": "0010",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_台北市災害應變中心",
        "En": "YouBike1.0_Emergency Operations Center of Taipei City"
      },
      "StationPosition": {
        "PositionLon": 121.566116667,
        "PositionLat": 25.0286611111,
        "GeoHash": "wsqqqk3dx"
      },
      "StationAddress": {
        "Zh_tw": "台北市信義區莊敬路391巷11弄2號",
        "En": "No.2, Aly. 11, Ln. 391, Zhuangjing Rd."
      },
      "BikesCapacity": 30,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:29+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0011",
      "StationID": "0011",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_三張犁",
        "En": "YouBike1.0_Sanchangli"
      },
      "StationPosition": {
        "PositionLon": 121.55762,
        "PositionLat": 25.034937,
        "GeoHash": "wsqqqj7x1"
      },
      "StationAddress": {
        "Zh_tw": "光復南路/基隆路一段364巷(鄰近大安親子館)",
        "En": "The S.E. side of Road Guangfu South & Ln. 346, Sec. 1, Keelung Rd."
      },
      "BikesCapacity": 36,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:23+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0012",
      "StationID": "0012",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_臺北醫學大學",
        "En": "YouBike1.0_Taipei Medical University"
      },
      "StationPosition": {
        "PositionLon": 121.561747,
        "PositionLat": 25.026679,
        "GeoHash": "wsqqq5ywf"
      },
      "StationAddress": {
        "Zh_tw": "台北醫學大學(吳興街220巷59弄)(鄰近台北醫學大學)",
        "En": "Aly. 59, Ln. 220, Wuxing St."
      },
      "BikesCapacity": 48,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:32+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0013",
      "StationID": "0013",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_福德公園",
        "En": "YouBike1.0_Fude Park"
      },
      "StationPosition": {
        "PositionLon": 121.58367,
        "PositionLat": 25.03809,
        "GeoHash": "wsqqqwn92"
      },
      "StationAddress": {
        "Zh_tw": "大道路/福德街路口北西側",
        "En": "The N.W. side of Road Dadao & St. Fude."
      },
      "BikesCapacity": 50,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:38+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0014",
      "StationID": "0014",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_榮星花園",
        "En": "YouBike1.0_Rongxing Park"
      },
      "StationPosition": {
        "PositionLon": 121.54037,
        "PositionLat": 25.06424,
        "GeoHash": "wsqqtdycz"
      },
      "StationAddress": {
        "Zh_tw": "五常街/龍江路口(西南側)(鄰近榮星公園(原榮星花園))",
        "En": "The S.W. side of St.Wuchang & Road Longjiang."
      },
      "BikesCapacity": 32,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:20+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0016",
      "StationID": "0016",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_松山家商",
        "En": "YouBike1.0_Songshan Vocational High School"
      },
      "StationPosition": {
        "PositionLon": 121.579135,
        "PositionLat": 25.036084,
        "GeoHash": "wsqqqtejz"
      },
      "StationAddress": {
        "Zh_tw": "林口街/福德街(東南側)",
        "En": "The S.E. side of St. Linkou & St. Fude."
      },
      "BikesCapacity": 30,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:30+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0017",
      "StationID": "0017",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_民生光復路口",
        "En": "YouBike1.0_Minsheng & Guangfu Intersection"
      },
      "StationPosition": {
        "PositionLon": 121.55514,
        "PositionLat": 25.05862,
        "GeoHash": "wsqqw1cc0"
      },
      "StationAddress": {
        "Zh_tw": "光復北路/民生東路(西北側)",
        "En": "The N.W. side of Road Guangfu S & Road Minsheng E."
      },
      "BikesCapacity": 34,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-10-20T12:15:39+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0018",
      "StationID": "0018",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_臺北市藝文推廣處",
        "En": "YouBike1.0_Taipei City Arts Promotion Office"
      },
      "StationPosition": {
        "PositionLon": 121.55261,
        "PositionLat": 25.049408,
        "GeoHash": "wsqqtbpgm"
      },
      "StationAddress": {
        "Zh_tw": "北寧路34號 對側(鄰近台北田徑場)",
        "En": "No.25, Sec. 3, Bade Rd."
      },
      "BikesCapacity": 40,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:41+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0019",
      "StationID": "0019",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_象山公園",
        "En": "YouBike1.0_Xiangshan Park"
      },
      "StationPosition": {
        "PositionLon": 121.56981,
        "PositionLat": 25.02863,
        "GeoHash": "wsqqqkk6m"
      },
      "StationAddress": {
        "Zh_tw": "松仁路153巷17號對面(鄰近象山步道)",
        "En": "No.17, Ln. 153, Songren Rd"
      },
      "BikesCapacity": 24,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:25+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0021",
      "StationID": "0021",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_民生敦化路口",
        "En": "YouBike1.0_Minsheng & Dunhua Intersection"
      },
      "StationPosition": {
        "PositionLon": 121.548982,
        "PositionLat": 25.057985,
        "GeoHash": "wsqqtctm2"
      },
      "StationAddress": {
        "Zh_tw": "敦化民生路口公車站旁",
        "En": "The side of bus stop- Dunhua Minsheng Intersection."
      },
      "BikesCapacity": 44,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:39+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0022",
      "StationID": "0022",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_松山車站",
        "En": "YouBike1.0_Songshan Rail Sta."
      },
      "StationPosition": {
        "PositionLon": 121.57845,
        "PositionLat": 25.048824,
        "GeoHash": "wsqqqxfxz"
      },
      "StationAddress": {
        "Zh_tw": "松山車站西出口外自行車格內(鄰近饒河街夜市/五分埔)",
        "En": "Bicycle parking lot- West exit in Songshan station"
      },
      "BikesCapacity": 44,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:32+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0023",
      "StationID": "0023",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_東新國小",
        "En": "YouBike1.0_Dongxin Elementary School"
      },
      "StationPosition": {
        "PositionLon": 121.602798,
        "PositionLat": 25.055074,
        "GeoHash": "wsqqx1hkq"
      },
      "StationAddress": {
        "Zh_tw": "東新國小側門(東明街62號前)",
        "En": "A side entrance of Dongxin Elementery School(front of No. 62, Dongxin St.)"
      },
      "BikesCapacity": 22,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:30+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0024",
      "StationID": "0024",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_信義建國路口",
        "En": "YouBike1.0_Xinyi & Jianguo Intersection"
      },
      "StationPosition": {
        "PositionLon": 121.53747,
        "PositionLat": 25.03293,
        "GeoHash": "wsqqmthgk"
      },
      "StationAddress": {
        "Zh_tw": "信義路三段/建國南路二段(西南側)(鄰近大安森林公園)",
        "En": "The N.S. side of Lianyun St. & Sec. 2, Xinyi Rd."
      },
      "BikesCapacity": 36,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:23+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0025",
      "StationID": "0025",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_永吉松信路口",
        "En": "YouBike1.0_Yongji & Songxin Intersection"
      },
      "StationPosition": {
        "PositionLon": 121.57205,
        "PositionLat": 25.04543,
        "GeoHash": "wsqqqrqh4"
      },
      "StationAddress": {
        "Zh_tw": "松信路/永吉路南西側人行道",
        "En": "The sidewalk- the S.W. side of Songxin Rd. & Yongji Rd."
      },
      "BikesCapacity": 24,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:34+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0026",
      "StationID": "0026",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_捷運昆陽站(1號出口)",
        "En": "YouBike1.0_MRT Kunyang Sta. (Exit 1)"
      },
      "StationPosition": {
        "PositionLon": 121.592375,
        "PositionLat": 25.050142,
        "GeoHash": "wsqqwbhze"
      },
      "StationAddress": {
        "Zh_tw": "捷運昆陽站1號出口外停車場旁",
        "En": "The side of parking lots in the MRT Kunyang station (exit 1)"
      },
      "BikesCapacity": 42,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:26+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0027",
      "StationID": "0027",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_捷運南港展覽館站(5號出口)",
        "En": "YouBike1.0_MRT Nangang Exhibition Center Sta. (Exit 5)"
      },
      "StationPosition": {
        "PositionLon": 121.61669,
        "PositionLat": 25.05469,
        "GeoHash": "wsqqx3nd4"
      },
      "StationAddress": {
        "Zh_tw": "捷運南港展覽館站（5號出口）南側",
        "En": "The N.E side of Academia Rd. & Shihmin Blvd."
      },
      "BikesCapacity": 38,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:25+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0028",
      "StationID": "0028",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_五常公園",
        "En": "YouBike1.0_Wuchang Park"
      },
      "StationPosition": {
        "PositionLon": 121.57467,
        "PositionLat": 25.04814,
        "GeoHash": "wsqqqrzgz"
      },
      "StationAddress": {
        "Zh_tw": "松隆路/虎林街30巷口(西南側)",
        "En": "The S.W side of Songlong Rd. & Hulin St."
      },
      "BikesCapacity": 32,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:21+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0029",
      "StationID": "0029",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_金山愛國路口",
        "En": "YouBike1.0_Jinshan & Aiguo Intersection"
      },
      "StationPosition": {
        "PositionLon": 121.52655,
        "PositionLat": 25.03164,
        "GeoHash": "wsqqmkugv"
      },
      "StationAddress": {
        "Zh_tw": "愛國東路/金山南路(西南側)",
        "En": "The S.W side of Aiguo St. & Jinshan Rd."
      },
      "BikesCapacity": 34,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:39+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0030",
      "StationID": "0030",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_基隆長興路口",
        "En": "YouBike1.0_Keelung & Changxing Intersection"
      },
      "StationPosition": {
        "PositionLon": 121.544352,
        "PositionLat": 25.017054,
        "GeoHash": "wsqqmf1yu"
      },
      "StationAddress": {
        "Zh_tw": "基隆路/長興街(東南側)",
        "En": "The S.W side of Keelung Rd. & Changsing St."
      },
      "BikesCapacity": 74,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:37+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0031",
      "StationID": "0031",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_辛亥新生路口",
        "En": "YouBike1.0_Xinhai & Xinsheng Intersection"
      },
      "StationPosition": {
        "PositionLon": 121.53456,
        "PositionLat": 25.022413,
        "GeoHash": "wsqqme4y0"
      },
      "StationAddress": {
        "Zh_tw": "辛亥路/新生南路(高架橋下)",
        "En": "Under the bridge- Sinhai Rd. & Shinsheng S. Rd."
      },
      "BikesCapacity": 30,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:39+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    },
    {
      "StationUID": "TPE0032",
      "StationID": "0032",
      "AuthorityID": "TPE",
      "StationName": {
        "Zh_tw": "YouBike1.0_捷運六張犁站",
        "En": "YouBike1.0_MRT Liuzhangli Sta."
      },
      "StationPosition": {
        "PositionLon": 121.553161,
        "PositionLat": 25.023884,
        "GeoHash": "wsqqq52q9"
      },
      "StationAddress": {
        "Zh_tw": "捷運出口外和平東路側",
        "En": "The outside of the MRT exit and the side of Heping E. Rd."
      },
      "BikesCapacity": 38,
      "ServiceType": 1,
      "SrcUpdateTime": "2021-11-18T13:04:24+08:00",
      "UpdateTime": "2021-11-18T13:05:29+08:00"
    }
  ];
let bikeAvaData=[
{
    "StationUID": "TPE0001",
    "StationID": "0001",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 1,
    "AvailableReturnBikes": 176,
    "SrcUpdateTime": "2021-11-18T13:03:31+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0002",
    "StationID": "0002",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 2,
    "AvailableReturnBikes": 29,
    "SrcUpdateTime": "2021-11-18T13:03:42+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0003",
    "StationID": "0003",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 13,
    "AvailableReturnBikes": 27,
    "SrcUpdateTime": "2021-11-18T13:03:24+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0004",
    "StationID": "0004",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 25,
    "AvailableReturnBikes": 35,
    "SrcUpdateTime": "2021-11-18T13:03:34+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0005",
    "StationID": "0005",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 18,
    "AvailableReturnBikes": 39,
    "SrcUpdateTime": "2021-11-18T13:03:37+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0006",
    "StationID": "0006",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 59,
    "AvailableReturnBikes": 20,
    "SrcUpdateTime": "2021-11-18T13:03:35+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0007",
    "StationID": "0007",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 34,
    "AvailableReturnBikes": 45,
    "SrcUpdateTime": "2021-11-18T13:03:16+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0008",
    "StationID": "0008",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 13,
    "AvailableReturnBikes": 46,
    "SrcUpdateTime": "2021-11-18T13:03:38+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0009",
    "StationID": "0009",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 10,
    "AvailableReturnBikes": 30,
    "SrcUpdateTime": "2021-11-18T13:03:39+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0010",
    "StationID": "0010",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 29,
    "AvailableReturnBikes": 17,
    "SrcUpdateTime": "2021-11-18T13:03:29+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0011",
    "StationID": "0011",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 22,
    "AvailableReturnBikes": 14,
    "SrcUpdateTime": "2021-11-18T13:03:23+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0012",
    "StationID": "0012",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 14,
    "AvailableReturnBikes": 33,
    "SrcUpdateTime": "2021-11-18T13:03:33+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0013",
    "StationID": "0013",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 27,
    "AvailableReturnBikes": 21,
    "SrcUpdateTime": "2021-11-18T13:03:38+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0014",
    "StationID": "0014",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 2,
    "AvailableReturnBikes": 28,
    "SrcUpdateTime": "2021-11-18T13:03:19+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0016",
    "StationID": "0016",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 12,
    "AvailableReturnBikes": 18,
    "SrcUpdateTime": "2021-11-18T13:03:30+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0017",
    "StationID": "0017",
    "ServiceStatus": 2,
    "ServiceType": 1,
    "AvailableRentBikes": 0,
    "AvailableReturnBikes": 0,
    "SrcUpdateTime": "2021-10-20T12:15:39+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0018",
    "StationID": "0018",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 39,
    "AvailableReturnBikes": 0,
    "SrcUpdateTime": "2021-11-18T13:03:41+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0019",
    "StationID": "0019",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 1,
    "AvailableReturnBikes": 28,
    "SrcUpdateTime": "2021-11-18T13:03:27+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0021",
    "StationID": "0021",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 2,
    "AvailableReturnBikes": 42,
    "SrcUpdateTime": "2021-11-18T13:03:39+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0022",
    "StationID": "0022",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 19,
    "AvailableReturnBikes": 25,
    "SrcUpdateTime": "2021-11-18T13:03:32+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0023",
    "StationID": "0023",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 9,
    "AvailableReturnBikes": 13,
    "SrcUpdateTime": "2021-11-18T13:03:30+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0024",
    "StationID": "0024",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 8,
    "AvailableReturnBikes": 28,
    "SrcUpdateTime": "2021-11-18T13:03:23+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0025",
    "StationID": "0025",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 24,
    "AvailableReturnBikes": 0,
    "SrcUpdateTime": "2021-11-18T13:03:34+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0026",
    "StationID": "0026",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 11,
    "AvailableReturnBikes": 27,
    "SrcUpdateTime": "2021-11-18T13:03:27+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0027",
    "StationID": "0027",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 4,
    "AvailableReturnBikes": 34,
    "SrcUpdateTime": "2021-11-18T13:03:25+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0028",
    "StationID": "0028",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 4,
    "AvailableReturnBikes": 10,
    "SrcUpdateTime": "2021-11-18T13:03:21+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0029",
    "StationID": "0029",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 24,
    "AvailableReturnBikes": 10,
    "SrcUpdateTime": "2021-11-18T13:03:42+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0030",
    "StationID": "0030",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 14,
    "AvailableReturnBikes": 60,
    "SrcUpdateTime": "2021-11-18T13:03:37+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0031",
    "StationID": "0031",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 6,
    "AvailableReturnBikes": 24,
    "SrcUpdateTime": "2021-11-18T13:03:39+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
},
{
    "StationUID": "TPE0032",
    "StationID": "0032",
    "ServiceStatus": 1,
    "ServiceType": 1,
    "AvailableRentBikes": 3,
    "AvailableReturnBikes": 35,
    "SrcUpdateTime": "2021-11-18T13:03:21+08:00",
    "UpdateTime": "2021-11-18T13:04:29+08:00"
}
];
let bikeShapeData =[
{
    "RouteName": "三元街(東北側1)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "和平西路2段98巷",
    "RoadSectionEnd": "寧波西街",
    "CyclingLength": 138,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.509912913931 25.028756758486,121.510477519076 25.0284152910771,121.51079469045 25.0282542774018,121.511369350755 25.0280592442443))"
},
{
    "RouteName": "三元街(東北側2)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "和平西路二段104巷",
    "RoadSectionEnd": "和平西路二段98巷",
    "CyclingLength": 267,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.507844929867 25.0305406081598,121.508198971795 25.0303170264937,121.508853437046 25.0297240234826,121.509352330098 25.0292233848301,121.509861944256 25.0287907797434))"
},
{
    "RouteName": "三元街(西南側)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "CyclingLength": 640,
    "FinishedTime": "102/12/31",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.508930039879 25.0294372539293,121.509993699401 25.0286004393527,121.511168929325 25.0280677068342,121.512199813238 25.0276534239417,121.513230694172 25.0274759594929,121.514508821203 25.027594269062))"
},
{
    "RouteName": "三元街(西南側1)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "泉州街",
    "RoadSectionEnd": "寧波西街",
    "CyclingLength": 750,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.51132106353 25.0278915505944,121.512297390226 25.0275853316615,121.51290357321 25.0274638082582,121.513694825425 25.0273836056062,121.514518253151 25.0274395035692))"
},
{
    "RouteName": "三元街(西南側2)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "泉州街",
    "RoadSectionEnd": "和平西路二段104巷",
    "CyclingLength": 640,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.507646447122 25.0304336800952,121.507839562849 25.0303802149249,121.508161427018 25.0300934381369,121.508864163332 25.0294032268049,121.509599087418 25.0287421709868,121.510331330379 25.0282852735876,121.511213782561 25.0279255764197))"
},
{
    "RouteName": "三民路 (東側)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "民權東路",
    "RoadSectionEnd": "健康路",
    "CyclingLength": 960,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.563152073382 25.0627233109086,121.563302278779 25.0612655094862,121.563438066093 25.0599282594735,121.563530938434 25.0593199145031,121.563834700422 25.0590945594358,121.563830669161 25.0587507512902,121.563624144743 25.0583644133507,121.563704605314 25.0563064030451,121.563913821084 25.0542775062967))"
},
{
    "RouteName": "三民路 (西側)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "民權東路",
    "RoadSectionEnd": "南京東路",
    "CyclingLength": 1250,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.56291603921 25.0626844374435,121.563160120167 25.0592731386062,121.563027013739 25.0591674466084,121.562947557439 25.0590617497372,121.563013937614 25.0586657092655,121.563276128523 25.05850048613,121.563297252988 25.0580849992534,121.563377551072 25.057989024621,121.563554411082 25.0568045078852,121.56384140515 25.0540442440261,121.563797146787 25.0528123108886,121.563763618264 25.0515512033213))"
},
{
    "RouteName": "三角形區塊",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "羅斯福路6段142巷",
    "RoadSectionEnd": "景福街",
    "CyclingLength": 600,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.536818143776 24.9980917850282,121.536005436064 24.9964970794016,121.535863277164 24.9965602828431,121.535654065619 24.9984272591145,121.53572380802 24.9984685825175,121.53680205106 24.9981112355164))"
},
{
    "RouteName": "三重路新民街口(東側)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "CyclingLength": 93,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.614135497211 25.0569891643823,121.614076488451 25.0561581842913))"
},
{
    "RouteName": "上塔悠433號帶狀公園之廊帶",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "樂群二路266巷",
    "RoadSectionEnd": "明水路",
    "CyclingLength": 1045,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.551704410737 25.0777182876142,121.5511679681 25.0773927531449,121.556146146527 25.0772615590673,121.557787652846 25.0771498076977,121.560469864047 25.0765910534382,121.561768054003 25.0763238188938,121.561819014886 25.0766104910214,121.558002908332 25.0774340490785,121.55710872364 25.077554302775,121.556203811445 25.0776065381372,121.55174731944 25.0777085674417))"
},
{
    "RouteName": "中和街/大業路周遭",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "CyclingLength": 400,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.50194943334 25.1389375934623,121.502496604208 25.1383742609003,121.502429544558 25.1382929113892,121.502661560917 25.1380676976051,121.502872104594 25.1378424931442,121.503092047017 25.1376215267142))"
},
{
    "RouteName": "中坡北路",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "松隆路",
    "RoadSectionEnd": "永吉路517巷8弄",
    "CyclingLength": 200,
    "FinishedTime": "1080831",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.5800139977 25.048258997061,121.58005700047 25.0480550034233,121.5801080031 25.0479209998964,121.580219996416 25.0477580038838,121.58033599814 25.0476149982333,121.58042700401 25.0475389968572,121.580494003392 25.047436998242,121.580538995373 25.0472599995101,121.580538996064 25.0469150025171,121.580537 25.0465289989856))"
},
{
    "RouteName": "中山北路(東側)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "市民大道",
    "RoadSectionEnd": "忠孝東路",
    "CyclingLength": 285,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.519893405135 25.0458019629713,121.520333286122 25.0467982611876,121.520837543416 25.0478674416076))"
},
{
    "RouteName": "中山北路(東側1)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "忠誠路",
    "RoadSectionEnd": "市民大道",
    "CyclingLength": 13100,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.521030667246 25.0482610929956,121.522100864792 25.0504966335596,121.522450893683 25.0513276562645,121.522658093032 25.0520979251423,121.522791196701 25.0531731429564,121.523145777096 25.0604241436845,121.522427475554 25.0657699139237,121.522793319966 25.0672870374508,121.523997063451 25.0719927118685,121.524430461517 25.073551788246,121.525464658814 25.0741196334664,121.525726395974 25.0746874827028,121.525829169405 25.0755206420576,121.525348080315 25.0771869545457,121.524385913553 25.0805195019622,121.524468085183 25.0807573171484,121.52539967051 25.0820908760614,121.525644600357 25.0828996882688,121.52580895976 25.0848134287343,121.525810437198 25.0856650559946,121.52596673668 25.0860787262869,121.526144501933 25.0862980550703,121.527173272666 25.0877010972946,121.52756427383 25.0883686033118,121.527719231146 25.0891721426067,121.527673913824 25.090209759478,121.527939586369 25.0922916880166,121.528248179527 25.093965495327,121.528323416724 25.0949785956189,121.528146524318 25.095758497045,121.527438961367 25.0982951159373,121.527042538008 25.0995880729743,121.526506643224 25.1010656142189,121.525070066925 25.1038263363758))"
},
{
    "RouteName": "中山北路(西側1)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "忠誠路",
    "RoadSectionEnd": "市民大道",
    "CyclingLength": 13100,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.524635556281 25.1041080854873,121.526162067328 25.1010565089126,121.526539080514 25.1002982351954,121.526873189574 25.0990541618893,121.528080854099 25.0943109524069,121.527320441671 25.0907317166034,121.527415071451 25.0891501213626,121.527161988437 25.0882767284235,121.52671041164 25.0875685122826,121.525930641607 25.0866864949727,121.525381546437 25.0854157943908,121.525245080746 25.0825872431174,121.524486350572 25.0815077355174,121.524156778406 25.0805836882369,121.524481665833 25.0789308331309,121.524935294115 25.0773945703956,121.525046774467 25.0766555827319,121.525437203481 25.074944830969,121.525241733298 25.0743608574019,121.524346712568 25.0737384591467,121.524151328431 25.0735293011995,121.524020324298 25.0731938119242,121.523056401371 25.0701220219911,121.522135401986 25.0662726938438,121.522072700443 25.0649306402673,121.522290632919 25.0635001988743,121.522637309399 25.0619919785014,121.522805116983 25.0607013584763,121.522790528463 25.0594495961122,121.52258969851 25.0568682931364,121.522316783487 25.0517443854897,121.52061223663 25.0482610974603))"
},
{
    "RouteName": "中山南路(東側1)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "信義路1段",
    "RoadSectionEnd": "愛國西路",
    "CyclingLength": 400,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.516760590189 25.0349296584285,121.516765950545 25.0351896942895,121.517146823358 25.0364266637736,121.517715456887 25.038531183065))"
},
{
    "RouteName": "中山南路(西側1)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "信義路1段",
    "RoadSectionEnd": "愛國西路",
    "CyclingLength": 400,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.516513823168 25.0349053549838,121.51634752882 25.0351386593148,121.516803498791 25.0367911940852,121.517350672454 25.0387158774268))"
},
{
    "RouteName": "中強公園",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "松仁路",
    "RoadSectionEnd": "信義路車行地下道西口",
    "CyclingLength": 100,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.568371653028 25.030866270108,121.569632287989 25.0308614077723))"
},
{
    "RouteName": "中正路(北側)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "承德路5段",
    "RoadSectionEnd": "雨農路",
    "CyclingLength": 3400,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.516937611067 25.0915600319184,121.520211251812 25.0935968150363,121.521236521039 25.0942751213741,121.521480940156 25.0943908052114,121.52406424284 25.0950214458976,121.528078166406 25.0959019608917,121.532049175906 25.0966561642651))"
},
{
    "RouteName": "中正路(南側)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "承德路5段",
    "RoadSectionEnd": "雨農路",
    "CyclingLength": 3400,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.516701574283 25.0910159219411,121.519770024976 25.0930223371296,121.521607338664 25.0942417234149,121.52201771327 25.0943437411641,121.527264121919 25.0955874042039,121.53194189016 25.0964424135426))"
},
{
    "RouteName": "中華公園周邊",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "敦化北路145巷",
    "RoadSectionEnd": "民生東路4段80巷",
    "CyclingLength": 60,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.552240845222 25.0533638885489,121.552809479998 25.0533857607612))"
},
{
    "RouteName": "中華路2段(南側)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "寧波西街",
    "RoadSectionEnd": "中華路2段467巷",
    "CyclingLength": 100,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.510178451381 25.0245765053473,121.510811451595 25.0244112385541))"
},
{
    "RouteName": "中華路2段(東北側)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "西藏路",
    "RoadSectionEnd": "泉州街",
    "CyclingLength": 630,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.504194439932 25.0299111643292,121.504588053178 25.0294670173303,121.504952165143 25.029054468637,121.505707205896 25.02826339463,121.506954426697 25.0269437127292,121.509246374355 25.024969020996,121.509360374058 25.0248900315907,121.509502530872 25.0248487102277,121.51205063241 25.0241924942479))"
},
{
    "RouteName": "中華路2段(西南側)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "中華路2段416巷",
    "RoadSectionEnd": "國興路",
    "CyclingLength": 350,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.505870822939 25.0278866902344,121.506938338996 25.0267590070868,121.509078744972 25.0249653699956))"
},
{
    "RouteName": "中華路2段300巷13弄",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "西藏路",
    "RoadSectionEnd": "中華路2段364巷",
    "CyclingLength": 150,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.503627154741 25.029218518131,121.503644581135 25.0295235283381,121.503664702903 25.0298382526823))"
},
{
    "RouteName": "中華路兩側",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "忠孝西路",
    "RoadSectionEnd": "愛國西路",
    "CyclingLength": 2400,
    "FinishedTime": "1041231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.50675594797 25.0375421148651,121.506747565278 25.0376508599385,121.507082509919 25.0388580392763,121.507264562912 25.0395208573278,121.507478804571 25.0401690930885,121.508212384131 25.042759565315,121.508959384019 25.0453499776394,121.509362381137 25.0467715237694,121.509504879845 25.0473607954174,121.509682236429 25.0479743592386))"
},
{
    "RouteName": "五常街(榮星公園北側)南側",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "建國北路3段",
    "RoadSectionEnd": "龍江路",
    "CyclingLength": 372,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.537349219325 25.0642782849452,121.540857552418 25.0642394108517))"
},
{
    "RouteName": "仁愛路(北側)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "市府路",
    "RoadSectionEnd": "景福門",
    "CyclingLength": 8200,
    "FinishedTime": "1041231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.517967579625 25.0393428512185,121.51809716583 25.0393867454503,121.520018464189 25.0391050020625,121.523142236524 25.0386824644385,121.525418426516 25.0384494714146,121.52827396868 25.0383720155041,121.528843437599 25.0383764178704,121.532191668366 25.0382884745034,121.532582146881 25.0383017280736,121.532900755968 25.0383666803985,121.533863108587 25.0383538638976,121.534515302633 25.0385456140323,121.53537981345 25.0385500221241,121.540640291872 25.0384121119572,121.541299700727 25.0384209964156,121.542044935775 25.0382063096235,121.543385202873 25.0381851911025,121.5462481219 25.0381138090341,121.547940386348 25.0380836180031,121.548001355597 25.0382631962003,121.54814815542 25.0384233272918,121.548412972652 25.0386174828476,121.548763619445 25.0387338781968,121.549111880719 25.0386637797011,121.549476250358 25.0384770413912,121.549631603463 25.038276738898,121.549722589327 25.0380667254508,121.551727206928 25.0380196356375,121.551822963982 25.0380152716048,121.552570507183 25.0379866011661,121.553384311948 25.0379681527764,121.554765139449 25.0379506807277,121.557290775653 25.0378938779214,121.557694872504 25.0378571975629,121.558941177772 25.0378010729609,121.560607661062 25.0377520202516,121.561455661056 25.0377402509729,121.56157409587 25.0376021075124,121.563484665342 25.0375785611709))"
},
{
    "RouteName": "仁愛路(南側)",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "市府路",
    "RoadSectionEnd": "景福門",
    "CyclingLength": 8200,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.518192884189 25.0390706720563,121.525137126941 25.038136893114,121.52931332823 25.0380585179857,121.53370141676 25.0379655690708,121.534336429139 25.0377716839835,121.534581518935 25.0377476544642,121.535191390501 25.0377187541178,121.536933486227 25.0376809344446,121.537511501927 25.0378941102912,121.538140476174 25.0379031459814,121.538483126035 25.0378201734832,121.538756042898 25.0377080485882,121.539999247549 25.0376295960502,121.540884961556 25.0375827962224,121.541378781002 25.0376152955974,121.541770530515 25.0377129509731,121.542054991236 25.0377547156921,121.542560421155 25.0377388775981,121.542753375746 25.0377376312685,121.542755884714 25.0377898404906,121.543359882965 25.0377733958609,121.543419143617 25.0377129257875,121.543537413727 25.0377059207888,121.544611302103 25.0377021964934,121.546396310579 25.0376775965667,121.547122331561 25.037644861716,121.547885900267 25.0376412809752,121.547941370837 25.0375089145216,121.548036161474 25.0373673930237,121.548216777894 25.037196710174,121.548440370119 25.0370680476472,121.548712233139 25.0369977174773,121.548903849427 25.0369788453255,121.549001579114 25.0370037177519,121.549262338897 25.037079339263,121.549533831795 25.0372618851831,121.549662238344 25.0374282760639,121.549731644651 25.0376238290941,121.552079919647 25.0375700640861,121.554411426021 25.0375055089342,121.557451043733 25.0374312386738,121.557747423494 25.0375548672537,121.563468579526 25.0374521932858))"
},
{
    "RouteName": "保儀路",
    "AuthorityName": "臺北市政府",
    "CityCode": "TPE",
    "City": "臺北市",
    "RoadSectionStart": "木柵路3段66巷",
    "RoadSectionEnd": "忠順街87巷",
    "CyclingLength": 150,
    "FinishedTime": "1021231",
    "UpdateTime": "2021-11-18T00:00:30+08:00",
    "Geometry": "MULTILINESTRING ((121.567357783199 24.9855960967387,121.568259004683 24.9867679288557))"
}
];

export { bikeCityData ,bikeAvaData, bikeShapeData };